function getShop(customerID, unfilledIcon, filledIcon) {
    $.get({
        url: 'https://api.fit.vet/v1/shop?shop_url=transformationprotein.myshopify.com&user_id=' + customerID,
        contentType: "application/json",
        dataType: 'json',
        method: 'GET',
        success: function(result) {
            //console.log(result);
            for(item of result) {
                var recipeExistsOnPage = document.getElementById("json-recipe-likes-hidden-id-"+item.recipe_id);

                if(recipeExistsOnPage) {
                    handleResponseOfLikes(item.recipe_id, item, unfilledIcon, filledIcon);
                }
            }
        },
        error: function(e) {
            //console.log("Error loading likes data, jQuery error message = " + e.message);
        }
    });
}

function executeLikeRecipeAPICall(id, customerID) {
    var currentRecipeLikeState = document.getElementById("json-recipe-likes-hidden-id-" + id).value;
    var recipeData = `{ "recipe_id": ` + id + `, "user_id": ` + customerID + `}`;

    var url = 'https://api.fit.vet/v1/unlike';
    if(currentRecipeLikeState == "false") {
        url = 'https://api.fit.vet/v1/like'
    }

    $.post({
        url: url,
        contentType: "application/json",
        method: 'POST',
        dataType: 'json',
        data: recipeData,
        success: function(result) {
            handleResponseOfLikes(id, result, unfilledIcon, filledIcon);
        },
        error: function(e) {
            alert('Sorry, there was a problem with the request, please try again later.');
            //console.log("Error liking/unliking recipe data, jQuery error message = " + e.message); 
        }
    });
}

function executeSubmitRecipeAPICall(formData, ingredients, stepByStepInstructions, beforeSendCallback, completeCallback, successCallback, errorCallback) {
    var newFormData = {...formData};
    for(i = 0; i < ingredients.length; i++) {
        newFormData["ingredients-" + i] = ingredients[i];
    }
    
    for(i = 0; i < stepByStepInstructions.length; i++) {
        newFormData["instructions-" + i] = stepByStepInstructions[i];
    }
    newFormData["shop"] = "transformationprotein.myshopify.com";
    
    const finalFormData = new FormData();
    for (var key in newFormData) {
        finalFormData.append(key, newFormData[key]);
    }
    
    $.ajax({
      type: "POST",
      url: "https://api.fit.vet/v1/recipe",
      data: finalFormData,
      contentType: false,
      processData: false,
      cache: false,
      dataType: 'json',
      beforeSend: function() {
          beforeSendCallback();
      },
      complete: function() {
          completeCallback();
      },
      success: function(data) {
          successCallback(data);
      },
      error: function(data) {
          errorCallback(data);
      }
    });
}

function recipeLikeClicked(id, customerID) {
    executeLikeRecipeAPICall(id, customerID);
}

function handleResponseOfLikes(id, likesResponse, unfilledIcon, filledIcon) {
    $("#json-recipe-likes-id-" + id).text(likesResponse.likes);
  	if (likesResponse.likes == 0){
      $("#json-recipe-likes-id-" + id).css('opacity', '0.0');
    }else {
      $("#json-recipe-likes-id-" + id).css('opacity', '1.0');
    }
    flickerLikeIcon(id, likesResponse.has_liked, unfilledIcon, filledIcon);
}

function flickerLikeIcon(id, hasLiked, unfilledIcon, filledIcon) {
    var src = unfilledIcon;
    if(hasLiked) {
        src = filledIcon;
    }

    document.getElementById("json-recipe-likes-hidden-id-" + id).value = hasLiked;
    document.getElementById("json-recipe-likes-src-" + id).src = src;
}

function recipeAddToCart(postData, id, successCallback, errorCallback) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: postData,
        dataType: 'json',
        success: function(data) { 
            successCallback(data, id);
        },
        error: function(error) {
            errorCallback(error, id);
        }
    });
}